//import siteSearch360 from './sitesearch360';
import featherlight from 'featherlight';

export default function () {
  featherlight();

  const $body = $('body');

  // Pricing
  const $pricing = $('.pricing, .pricingTableDesktop');

  $pricing.on('click', '.pricing-body-toggle', function (event) {
    event.preventDefault();

    const $tbody = $(this).parent('tbody');

    if (!$tbody.hasClass('pricing-body-first')) {
      $tbody.toggleClass('collapsed').toggleClass('open');
    }
  });

  // Pricing Sticky Product Header
  function checkPricingHeader() {
    const scrollPosition = $(window).scrollTop();
    const $navigation = $('section:visible .pricing-sticky-navigation');
    const navigationHeight = $navigation.outerHeight(true);
    const headerHeight = $('header').outerHeight(true);
    const $pricingTable = $navigation.next();
    let pricingTableTop = 0;
    if ($navigation.length > 0 && $navigation.parent().parent().css('display') !== 'none') {
      if (document.querySelector('.pricing-product-title')) {
        pricingTableTop = $pricingTable.find('.pricing-product-title').position().top - 10;
      } else {
        pricingTableTop = $pricingTable.find('.pricing-category').position().top + 30;
      }
      let pricingTableBottom = $pricingTable.position().top + $pricingTable.outerHeight(true) - 39;

      if ((scrollPosition + headerHeight) > pricingTableTop && (scrollPosition + headerHeight) < (pricingTableBottom + headerHeight - navigationHeight - 150)) {
        $navigation.addClass('pricing-sticky-navigation-show');
      } else {
        $navigation.removeClass('pricing-sticky-navigation-show');
      }

      if ((scrollPosition + headerHeight - 500) > pricingTableTop && (scrollPosition + headerHeight) < (pricingTableBottom + headerHeight - navigationHeight)) {
        $navigation.addClass('pricing-sticky-navigation-animate');
      } else {
        $navigation.removeClass('pricing-sticky-navigation-animate');
      }
      return true;
    }
  }

  if (document.querySelector('.pricing-sticky-navigation')) {
    $(window).scroll(checkPricingHeader);
  }

  // Pricing 2021 Sticky Header
  function checkPricing2021Header() {
    const scrollPosition = $(window).scrollTop();
    $('.pricing-2021-box-sticky-header').each(function() {
      const $navigation = $(this);
      const navigationHeight = $navigation.outerHeight(true);
      const headerHeight = $('header').outerHeight(true);
      const $pricingTable = $navigation.next().find('.pricing-2021-box');
      let pricingTableTop = 0;
      if ($navigation.length > 0) {
        pricingTableTop = $pricingTable.position().top;
        var pricingTableBottom = $pricingTable.position().top + $pricingTable.outerHeight(true);

        if ((scrollPosition + headerHeight) > pricingTableTop && (scrollPosition + headerHeight) < (pricingTableBottom + headerHeight - navigationHeight - 290)) {
          $navigation.addClass('pricing-2021-box-sticky-header-show');
        } else {
          $navigation.removeClass('pricing-2021-box-sticky-header-show');
        }

        if ((scrollPosition + headerHeight - 500) > pricingTableTop && (scrollPosition + headerHeight) < (pricingTableBottom + headerHeight - navigationHeight)) {
          $navigation.addClass('pricing-2021-box-sticky-header-animate');
        } else {
          $navigation.removeClass('pricing-2021-box-sticky-header-animate');
        }
        return true;
      }
    });
  }

  if (document.querySelector('.pricing-2021-box-sticky-header')) {
    $(window).scroll(checkPricing2021Header);
  }

  // Support accordion
  const $accordionSupport = $('#accordion-support');
  const $accordionSupportIndicators = $('.section-support-indicators');

  $accordionSupport.find('h5 > a').on('click', function () {
    $accordionSupportIndicators.find('[data-support]').removeClass('active');
    $accordionSupportIndicators.find('[data-support="' + $(this).parent().parent().data('support') + '"]').addClass('active');
  });

  // Screenshots
  $('.screenshots').on('mouseenter', '[data-screenshot]', function (event) {
    event.preventDefault();

    const $this = $(this);
    $this.siblings().removeClass('active');
    $this.addClass('active');

    if ($this.data('screenshot').length > 0) {
      var screenshot = $this.parent().parent().parent().parent().find('.browser-content');
      screenshot.fadeTo(100, 0);
      setTimeout(function () {
        screenshot.find('img').attr('src', $this.data(window.devicePixelRatio > 1 ? 'screenshot-retina' : 'screenshot'));
        screenshot.find('img').attr('srcset', $this.data('screenshot') + ' 1x, ' + $this.data('screenshot-retina') + ' 2x');
        screenshot.fadeTo(100, 1);
      }, 150);
    }
  });

  // Show hidden siblings
  $(document).on('click', '[data-show-hidden]', function (event) {
    event.preventDefault();

    const $this = $(this);
    $this.siblings('.hidden').removeClass();
    $this.remove();
  });

  // Featherlight Lighbox Caption
  $('.lightbox').featherlight({
    afterContent: function () {
      let caption = this.$currentTarget.find('img').attr('alt');
      this.$instance.find('.caption').remove();
      $('<div class="lightbox-caption">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
    }
  });

  // Post ratings
  function likePost(uid, amount, type, uri) {
    $.ajax({
      url: '/ajax/like',
      type: 'post',
      data: { uid: uid, amount: amount, type: type, uri: uri },
      success: function () {
        $('.post-single, .page-template-help-article').addClass('post-popular-voted');
        if (amount) {
          $('.post-popular-likes').html(parseInt($('.post-popular-likes').html()) + 1);
        }
        $('.post-popular-total').html(parseInt($('.post-popular-total').html()) + 1);
        $('.post-popular-thanks').addClass('post-popular-thanks-active').delay(5000).queue(function (next) {
          $(this).removeClass('post-popular-thanks-active');
          next();
        });
        if (type === 'help' && amount < 4) {
          modal('vote');
        }
      }
    });
  }

  if ($body.hasClass('page-template-blog-post')
    || $body.hasClass('page-template-blog-post-2019')
    || $body.hasClass('page-template-blog-post-blocks')
    || $body.hasClass('page-template-help-article')
    || $body.hasClass('page-template-guide-post')
    || $body.hasClass('page-template-guide-post-2019')
    || $body.hasClass('page-template-guide-post-blocks')
    || $body.hasClass('page-template-page-webex-guide-article')) {
    if (document.getElementsByClassName('post-popular').length) {
      window.likePost = likePost;

      $('.post-popular-buttons .btn').mouseenter(function () {
        var $buttons = $('.post-popular-buttons .btn');
        var id = $(this).index();

        $buttons.removeClass('btn-primary');
        $buttons.slice(0, id - 1).addClass('btn-primary');
      });
    }
  }

  // Area Code checker
  function check_areacode(code) {
    var $areaCodeBox = $('.section-details-areacode');
    var $areaCodeButton = $('.section-details-areacode .btn-order');
    var $result = $('.areacode-result');
    if (code !== '') {
      $.getJSON('/ajax/areacode?areacode=' + code.replace(/^0+/, ''),
        function (data) {
          var $city = data.city;
          if ($city && $city !== 'false') {
            $areaCodeButton.show();
            $areaCodeBox.removeClass('areacode-positive areacode-negative').addClass('areacode-positive');
            $result.html($areaCodeBox.data('text-positive').replace('#city', $city).replace('#code', code));
          } else {
            $areaCodeButton.hide();
            $areaCodeBox.removeClass('areacode-positive areacode-negative').addClass('areacode-negative');
            $result.html($areaCodeBox.data('text-negative').replace('#city', $city).replace('#code', code));
          }
        });
    } else {
      $areaCodeButton.hide();
      $areaCodeBox.removeClass('areacode-positive areacode-negative').addClass('areacode-negative');
      $result.html($areaCodeBox.data('text-empty'));
    }
  }

  if ($('.section-details-areacode').length > 0) {
    $('.section-details-areacode button').click(function (event) {
      event.preventDefault();
      check_areacode($('#areacode').val());
    });
    window.check_areacode = check_areacode;
  }

  // Tab generator
  function tab(tab) {
    $('.' + tab + ' img').trigger('unveil');
    $('.section-tab').addClass('hidden');
    $('.tab').removeClass('tab-active');
    $('.' + tab).removeClass('hidden');
    $('.tab-' + tab).addClass('tab-active');
  }

  if ($('.section-tabs').length > 0) {
    $('.section-tab').addClass('hidden');
    $('.section-tab').first().removeClass('hidden');
    $('.tab').first().addClass('tab-active');
    window.tab = tab;
  }

  // Move Page Section Navigation to Header
  if ($('.section-navigation').length > 0) {
    $('.section-navigation').appendTo('header');
    $body.addClass('page-with-section-navigation');
  }

  /*if (document.querySelector('.btn-search:not(#button-topSearchBox), .navigation-main-search, .navigation-footer-search, .ss360SearchBox')) {
    siteSearch360();
  }*/

  // Slidebox
  function slidebox(button) {
    const slidebox = button.parent().parent();
    const amount = slidebox.data('amount');
    const box = slidebox.data('box');
    let destination = 1;

    if (button.hasClass('btn-prev')) {
      if (box === 1) {
        destination = amount;
      } else {
        destination = box - 1;
      }
    } else {
      if (box === amount) {
        destination = 1;
      } else {
        destination = box + 1;
      }
    }
    slidebox.data('box', destination);
    slidebox.find('.slidebox-counter-current').html(destination);
    slidebox.find('.slidebox-box').removeClass('active');
    slidebox.find('.slidebox-box-' + destination).addClass('active');
  }

  if ($('.block-slidebox, .slidebox').length > 0) {
    $('.block-slidebox .btn, .slidebox .btn').on('click', function (event) {
      event.preventDefault();
      slidebox($(this));
    });

    window.slidebox = slidebox;
  }

  // Help Overview
  if (document.querySelector('#help-overview-search')) {
    $('#help-overview-search').on('input', function () {
      var searchStr;
      searchStr = $('#help-overview-search').val().toLowerCase();
      $('#help-overview-table .help-overview-table-data').each(function () {
        var $this;
        $this = $(this);
        if ($this.find('.help-overview-data-id').text().toLowerCase().indexOf(searchStr) === -1 && $this.find('.help-overview-data-title').text().toLowerCase().indexOf(searchStr) === -1 && (!$this.find('.help-overview-data-keywords').data('content') || ($this.find('.help-overview-data-keywords').data('content') && $this.find('.help-overview-data-keywords').data('content').toLowerCase().indexOf(searchStr) === -1))) {
          $this.hide();
        } else {
          $this.show();
        }
      });
    });
  }

  // Demo device form
  if (document.querySelector('#form-demo')) {
    $('#customertype').change(function () {
      var $this;
      $this = $(this);
      if ($this.val() === 'partner') {
        $('#additional-partner-data').show();
      } else {
        $('#additional-partner-data').hide();
      }
    });
  }

  // Tooglescript
  function togglescript(id) {
    $('#' + id + ' .togglescript-item').toggleClass('togglescript-hidden');
  }

  if (document.querySelector('.togglescript-activate')) {
    window.togglescript = togglescript;
  }

  // Pricing 2021 Unveil/Veil Blocks
  if (document.querySelector('.pricing-2021-box')) {
    $('.pricing-2021-cell-style-block-headline-row').click(function () {
      var $this = $(this);
      var $identifier = $this.data('block');
      $('[data-block="' + $identifier + '"]:not(.pricing-2021-cell-style-block-headline-row)').toggleClass('hidden');
      $('[data-block="' + $identifier + '"].pricing-2021-cell-style-block-headline').toggleClass('block-hidden');
    });
  }

  if (document.querySelector('.section-switch')) {
    $('.pricing-switch-item').on('click', function () {
      $('.section-switch').removeClass('section-switch-show');
      $('.section-switch[data-type="' + $(this).data('type') + '"]').addClass('section-switch-show');
      $('.pricing-switch-item').removeClass('pricing-switch-item-active');
      $('.pricing-switch-item[data-type="' + $(this).data('type') + '"]').addClass('pricing-switch-item-active');
    });
  }
}
